import Box from "./Box";

export default function FlexBox({ $pointer, children, ...rest }) {
  return (
    <Box {...{ $display: "flex", $alignItems: "center", ...rest }} style={{cursor:$pointer}}>
      {children}
    </Box>
  );
}
